import { Route, Routes } from "react-router-dom";
import ParentInfoPage from "./ParentInfoPage";
import ReportPage from "../ReportPage";

const ParentPage = () => {
  return (
    <>
      <Routes>
        <Route index element={<ParentInfoPage />} />
        <Route path="report" element={<ReportPage />} />
      </Routes>
    </>
  );
};

export default ParentPage;
